import { LabelType } from '../../../../../elements/public_api';
import { Cell, CellType } from '../_base/table-cell.entity';

export class StatusCell extends Cell {
    constructor(public readonly value: string, public readonly labelType: LabelType) {
        super(CellType.STATUS);
    }
}
